import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { WhatWeOffer } from "./components/whatWeOffer";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import { useLanguage } from "./context/LanguageContext";  // Import the useLanguage hook
import SmoothScroll from "smooth-scroll";
import "./App.css";

// Initialize smooth scroll
export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const { language } = useLanguage(); // Get language from context
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    document.documentElement.setAttribute("lang", language); // Set the document language
    document.documentElement.setAttribute("dir", language === "ar" ? "rtl" : "ltr"); // Set the direction for RTL languages like Arabic
    setLandingPageData(JsonData[language]); // Load the data based on the current language
    console.log(JsonData[language]);
  }, [language]); // Effect will run whenever the language is updated

  return (
    <div>
      <Navigation data={landingPageData.Navigation}/> {/* No need to pass switchLanguage as it's now in context */}
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <WhatWeOffer data={landingPageData.WhatWeOffer} />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
